import React, { useState, createContext } from 'react';

interface SettingsContextValue {
  allowedPrintSlippage: number | string;
  allowedBurnSlippage: number;
  setAllowedPrintSlippage: any;
  setAllowedBurnSlippage: any;
  showSettings: boolean;
  toggleSettings: any;
  setShowSettings: any;
}

const SettingsContext = createContext<SettingsContextValue>({
  allowedPrintSlippage: 0,
  allowedBurnSlippage: 0,
  setAllowedPrintSlippage: () => {},
  setAllowedBurnSlippage: () => {},
  showSettings: true,
  toggleSettings: () => {},
  setShowSettings: () => {},
});

const SettingsContextProvider = ({ children }: any) => {
  const [allowedPrintSlippage, setAllowedPrintSlippage] = useState<number>(0);
  const [allowedBurnSlippage, setAllowedBurnSlippage] = useState<number>(0);
  const [showSettings, setShowSettings] = useState<boolean>(false);

  const toggleSettings = () => {
    setShowSettings((prev) => !prev);
  }

  return (
    <SettingsContext.Provider
      value={{
        allowedPrintSlippage,
        allowedBurnSlippage,
        setAllowedPrintSlippage,
        setAllowedBurnSlippage,
        showSettings,
        toggleSettings,
        setShowSettings,
      }}
    >
      {children}
    </SettingsContext.Provider>
  );
};

const useSettingsContext = () => {
  const context = React.useContext(SettingsContext);
  if (context === undefined) {
    throw new Error('useSettingsContext must be used within a SettingsContextProvider');
  }
  return context;
};

export { SettingsContextProvider, useSettingsContext };
